const Copyright = () => {
    const year = new Date().getFullYear()

    return (
        <div className="py-4 sm:py-6 border-t border-gray-200 dark:border-gray-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4 px-3 sm:px-4 md:px-6 lg:px-8">
                <p className="text-center sm:text-left text-xs sm:text-sm text-gray-600 dark:text-gray-400 order-2 sm:order-1">
                    Copyright © {year} MemoSlate.com. All rights reserved.
                </p>
                <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 order-1 sm:order-2">
                    <a
                        href="/privacy"
                        className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors whitespace-nowrap"
                    >
                        Privacy Policy
                    </a>
                    <span className="text-gray-300 dark:text-gray-600 hidden sm:inline">|</span>
                    <a
                        href="/terms"
                        className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors whitespace-nowrap"
                    >
                        Terms & Conditions
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Copyright
